<template>
    <div class="container pt-5">
        <!-- Outer Row -->
        <div class="row justify-content-center">
            <div class="col-xl-10 col-lg-12 col-md-9">
                <div class="card o-hidden border-0 shadow-lg my-5">
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <!-- <div
                                class="col-lg-6 d-none d-lg-block bg-login-image"
                            >-->
                            <div class="col-lg-6 d-none d-lg-flex pl-2 align-items-center justify-content-center w-100">
                                <app-client-pet v-if="isReseller" style="margin-left: 50px; padding-bottom: 50px !important"></app-client-pet>
                                <app-vecindapp-banner v-else style="padding-left: 35px; margin-top: 10px !important" size="lg"></app-vecindapp-banner>
                            </div>
                            <div class="col-lg-6 d-lg-none" style="margin-top: 30px">
                                <app-client-banner v-if="isReseller" size="sm"></app-client-banner>
                                <app-vecindapp-banner v-else size="sm"></app-vecindapp-banner>
                                <!-- <img :src="currentClient.pet_url" v-else alt="" /> -->
                            </div>
                            <div class="col-lg-6">
                                <div class="p-lg-5 p-2">
                                    <!-- <div class="text-center">
                                        <h1 class="h4 text-gray-900 mb-4">
                                            VECINDAPP
                                        </h1>
                                    </div> -->
                                    <form class="user">
                                        <div class="form-group">
                                            <b-form-input
                                                type="text"
                                                class="form-control form-control-user"
                                                id="exampleInputEmail"
                                                aria-describedby="emailHelp"
                                                placeholder="Ingrese su usuario..."
                                                v-model="username"
                                                @input="$v.username.$touch()"
                                                :state="!$v.username.$dirty ? null : !$v.username.$error"
                                            />
                                        </div>
                                        <div class="form-group">
                                            <b-form-input
                                                type="password"
                                                class="form-control form-control-user"
                                                id="exampleInputPassword"
                                                placeholder="Clave"
                                                v-model="password"
                                                @input="$v.password.$touch()"
                                                :state="!$v.password.$dirty ? null : !$v.password.$error"
                                            />
                                        </div>

                                        <a href="index.html" class="btn btn-primary btn-user btn-block" @click.prevent="onLogin">Login</a>

                                        <hr />
                                        <div class="zm-login-methods__title">O inicie sesión con</div>
                                        <div class="social-buttons">
                                            <a
                                                v-if="authenticationMethod === 'whatsapp'"
                                                key="whatsapp"
                                                class="social-button whatsapp"
                                                @click="openModal('whatsapp-login-window')"
                                                title="WhatsApp"
                                            >
                                                <i class="fab fa-whatsapp fa-2x"></i>
                                            </a>
                                            <a
                                                v-if="authenticationMethod === 'sms'"
                                                key="sms"
                                                class="social-button sms"
                                                @click="openModal('sms-login-window')"
                                                title="Sms"
                                            >
                                                <i class="fas fa-envelope-open-text fa-2x"></i>
                                            </a>

                                            <a href="auth/google" class="social-button google" title="Google">
                                                <img src="/img/gmail-logo.png" alt="Logo de Gmail" />
                                            </a>
                                            <!--
                                            <a href="auth/facebook" class="social-button facebook" title="Facebook">
                                                <i class="fab fa-facebook fa-2x"></i>
                                            </a> -->
                                        </div>
                                        <div class="social-buttons">
                                            <span v-if="authenticationMethod === 'whatsapp'" class="span">WhatsApp</span>
                                            <span v-if="authenticationMethod === 'sms'" class="span">Mensaje texto</span>
                                            <span class="span">Google</span>
                                            <!-- <span class="span">Facebook</span> -->
                                        </div>

                                        <b-row v-if="!!errorMessage" class="mt-2">
                                            <b-col class="text-danger"> {{ errorMessage }} </b-col>
                                        </b-row>
                                    </form>
                                    <!-- <b-row>
                                        <b-col>
                                            <b-btn variant="link" @click="openModal('whatsapp-login-window')" class="d-flex align-items-center"
                                                ><i class="fab fa-whatsapp fa-2x" style="color: #00d500"></i>
                                                <span class="ml-1">Ingresar con mi Whatsapp</span></b-btn
                                            >
                                        </b-col>
                                    </b-row> -->
                                    <hr />
                                    <div class="text-center">
                                        <b-btn variant="link" @click="goToPasswordReset">Olvidé la contraseña</b-btn>
                                    </div>
                                    <div class="text-center">
                                        <a :href="dataLink" class="btn btn-link">Quiero registrarme</a>
                                    </div>
                                </div>
                                <div v-if="isReseller">
                                    <app-vecindapp-banner-footer size="sm"></app-vecindapp-banner-footer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            title="Autorización de tratamiento de datos"
            id="data-authorization-window"
            ok-title="Autorizo"
            cancel-title="No Autorizo"
            :ok-disabled="!authorized || !!busy"
            ok-variant="success"
            cancel-variant="danger"
            @ok.prevent="onAuthorizationGranted"
        >
            <b-card>
                <b-card-text>
                    <b-row>
                        <b-col>
                            <b-form-checkbox id="status" v-model="authorized" size="lg"
                                >Autorizo el
                                <a href="https://vecindapp.com.co/autorizacion-para-tratamiento-de-datos-personales/" target="_blank" class="authorization-link"
                                    >tratamiento de mis datos personales</a
                                >
                                de acuerdo a la
                                <a href="https://vecindapp.com.co/politica-de-privacidad/" target="_blank" class="authorization-link"
                                    >política de tratamiento de datos</a
                                >
                                de Intus Aliado Tecnológico S.A.S.</b-form-checkbox
                            >
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <label for="notification-channel">Seleccione el canal preferido para recibir notificaciones</label>
                            <b-form-radio-group
                                stacked
                                :options="notificationChannels"
                                value-field="id"
                                text-field="name"
                                id="notification-channel"
                                v-model="notificationChannelId"
                            ></b-form-radio-group>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card>
        </b-modal>
        <app-modal
            id="whatsapp-login-window"
            title="Ingreso con Whatsapp"
            @ok="waitingCode ? sendCode() : requestCode()"
            :ok-title="waitingCode ? 'Enviar código' : 'Solicitar código'"
            :ok-disabled="busy"
        >
            <div v-if="!waitingCode">
                <b-row class="pb-3">
                    <b-col> Si tu número no es de Colombia, recuerda agregar + y el código de tu país ej (+34678882239) </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-form-input label="Número de Whatsapp" v-model="whatsapp" autofocus></app-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="!!whatsappLoginError">
                    <b-col class="text-danger">
                        {{ whatsappLoginError }}
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                <b-row>
                    <b-col> Por favor ingresa el código que recibiste por Whatsapp para ingresar </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-form-input type="number" label="Código de 4 dígitos" v-model="whatsappCode"></app-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col> Tiempo restante: {{ whatsappTimer }} </b-col>
                </b-row>
            </div>
        </app-modal>
        <app-modal
            id="sms-login-window"
            title="Ingreso con código de verificación"
            @ok="smsWaitingCode ? smsSendCode() : smsRequestCode()"
            :ok-title="smsWaitingCode ? 'Enviar código' : 'Solicitar código'"
            :ok-disabled="busy"
        >
            <div v-if="!smsWaitingCode">
                <b-row class="pb-3">
                    <b-col> Si tu número no es de Colombia, recuerda agregar + y el código de tu país ej (+34678882239) </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-form-input label="Número de celular" v-model="sms" autofocus></app-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="!!smsLoginError">
                    <b-col class="text-danger">
                        {{ smsLoginError }}
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                <b-row>
                    <b-col> Por favor ingresa el código que recibiste por mensaje de texto para ingresar </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-form-input type="number" label="Código de 4 dígitos" v-model="smsCode"></app-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col> Tiempo restante: {{ smsTimer }} </b-col>
                </b-row>
            </div>
        </app-modal>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapMutations, mapActions } from 'vuex'
import appClientPet from '@controls/ClientPet'
import appClientBanner from '@layout/ClientBanner'
import appVecindappBannerFooter from '@layout/VecindappBannerFooter'
import * as mutations from '@store/_mutations'
import * as actions from '@store/_actions'
import Encryption from '@utils/encryption'
export default {
    components: {
        appClientPet,
        appVecindappBannerFooter,
        appClientBanner,
    },
    props: {
        error: {
            type: String,
        },
    },
    data: () => ({
        authorized: false,
        busy: false,
        loginPage: '',
        password: '',
        username: '',
        notificationChannelId: '',
        notificationChannels: [],
        clientChecked: false,
        whatsapp: '',
        waitingCode: false,
        whatsappCode: '',
        whatsappLoginError: '',
        whatsappTimer: '',
        whatsappTimerInterval: null,
        errorMessage: '',
        dataLink: '',
        sms: '',
        smsWaitingCode: false,
        smsCode: '',
        smsLoginError: '',
        smsTimer: '',
        smsTimerInterval: null,
        authenticationMethod: 'whatsapp',
    }),
    validations: {
        username: { required },
        password: { required },
    },
    methods: {
        ...mapActions({
            setCurrentProfile: actions.SET_CURRENT_PROFILE,
            loadPersonCapabilities: actions.LOAD_PERSON_CAPABILITIES,
        }),
        ...mapMutations({
            setCurrentUser: mutations.SET_CURRENT_USER,
            setCapabilities: mutations.SET_CAPABILITIES,
            setClientConfig: mutations.SET_CLIENT_CONFIG,
            setIsReseller: mutations.SET_IS_RESELLER,
        }),
        async onLogin() {
            this.$v.$touch()
            if (this.$v.$invalid) return toastr.warning('Debe escribir el usuario y la contraseña')

            const credentials = {
                username: this.username,
                password: this.password,
                timestamp: Date.now(),
            }

            const { data: encryptedData, iv } = await Encryption.encrypt(credentials)

            const { data } = await this.$repo.post('login', {
                encryptedData,
                iv,
            })

            if (!!data.status) {
                this.processLogin(data.user)
            } else {
                toastr.warning('Usuario o contraseña incorrectos')
            }
        },
        async processLogin(user) {
            this.setCurrentUser(user)
            this.loginPage = 'selectProfilePage'

            // mantener la session con el local storage
            localStorage.setItem('user', JSON.stringify(user))
            // expiration time
            localStorage.setItem('expiration', new Date().getTime() + 90 * 24 * 60 * 60 * 1000)

            if (user.profiles.length === 1) {
                const profile = user.profiles[0]
                await this.setCurrentProfile(profile)
                this.loadUserCapabilities()
                //this.loginPage = profile.login_page
                this.logProfileUsed(profile.id)
            }
            if (user.change_password_required === 1) {
                this.loginPage = 'changePasswordPage'
            }
            if (!!user.opt_in) return this.$router.push({ name: this.loginPage })

            // Solicitar autorizacion de tratamiento de datos

            this.openModal('data-authorization-window')
        },
        async logProfileUsed(profileId) {
            const { data } = await this.$repo.post(`users/${this.currentUser.id}/used-profiles`, { profileId })
        },
        async loadUserCapabilities() {
            const {
                data: { capabilities },
            } = await this.$repo.get(`users/${this.currentUser.id}/capabilities`)
            const caps = Array.from(new Set(capabilities))
            this.setCapabilities(caps)
        },
        async validateAction() {
            const { p, a } = this.$route.query
            if (!!a) {
                try {
                    const { data } = await this.$repo.post(`login-payload`, {
                        payload: p,
                    })
                    if (data.status) {
                        this.setCurrentUser(data.result.user)
                        this.setCurrentClient(data.result.client)
                        this.setCurrentProfile(data.result.profile)
                        this.loadUserCapabilities()
                        if (!!data.result.person) {
                            this.setCurrentPerson(data.result.person)
                            this.loadPersonCapabilities()
                        }
                        !!data.result.venue && this.setCurrentVenue(data.result.venue)
                        this.$router.push({
                            name: a,
                            params: { p },
                        })
                        toastr.success(data.msg)
                    } else {
                        toastr.warning(data.msg)
                    }
                } catch (error) {
                    // toastr.error('Ocurrió un error, por favor intente de nuevo más tarde')
                }
                this.$router.push({ name: a, params: { payload: p } })
            }
        },
        goToPasswordReset() {
            this.$router.push({ name: 'passwordReset' })
        },
        async onAuthorizationGranted() {
            try {
                const { data } = await this.$repo.post(`users/${this.currentUser.id}/opt-in`, { notificationChannelId: this.notificationChannelId })
                this.$router.push({ name: this.loginPage })
            } catch (error) {
                toastr.error('Ocurrió un error, por favor intente de nuevo más tarde')
            }
        },
        async createLink() {
            const domain = `${window.location.protocol}/register?domain=${window.location.host}`
            this.dataLink = domain
        },
        async getClientConfig() {
            try {
                const { data } = await this.$repo.get(`domain-config`, { domain: window.location.host })
                if (data.clientConfig) {
                    this.setClientConfig(data.clientConfig)
                }
                this.authenticationMethod = data.clientConfig.find((config) => config.key === 'otp-channel')?.value ?? 'whatsapp'
            } catch (error) {
                //console.log('Ocurrió un error al cargar el metodo de autenticación')
            }
        },
        async loadNotificationChannels() {
            const { data: notificationChannels } = await this.$repo.get('notification-channels')
            this.notificationChannels = notificationChannels
            this.notificationChannelId = notificationChannels.find((item) => !!item.default).id
        },
        async requestCode() {
            try {
                this.busy = true
                const {
                    data: { error = null, time },
                } = await this.$repo.post('request-whatsapp-code', { whatsapp: this.whatsapp })

                if (!!error) return (this.whatsappLoginError = error)
                this.waitingCode = true
                this.startCounter(time)
            } catch (error) {
                toastr.error(error.message)
            } finally {
                this.busy = false
            }
        },
        async sendCode() {
            try {
                this.busy = true
                if (!this.whatsappCode || this.whatsappCode.length !== 4) return toastr.error('Debe diligenciar el código de 4 dígitos')

                const { data } = await this.$repo.post('login', { whatsappCode: this.whatsappCode })

                return !!data.status ? this.processLogin(data.user) : toastr.warning('Usuario o contraseña incorrectos')
            } catch (error) {
                console.log({ error })
                toastr.error('Ocurrió un error enviando el código, por favor intente más tarde o use otro medio de autenticación.')
            } finally {
                this.busy = false
            }
        },
        startCounter(minutes) {
            const time = moment().add(minutes, 'm').format('X')
            this.whatsappTimerInterval = setInterval(() => {
                const now = moment().format('X')
                const distance = parseInt(time) - parseInt(now)

                if (distance < 0) {
                    clearInterval(this.whatsappTimerInterval)
                    this.whatsappTimerInterval = null
                    this.waitingCode = false
                }

                this.whatsappTimer = moment.unix(distance).format('mm:ss')
            }, 1000)
        },
        async smsRequestCode() {
            try {
                this.busy = true
                const {
                    data: { error = null, time },
                } = await this.$repo.post('request-sms-code', { sms: this.sms })

                if (!!error) return (this.smsLoginError = error)
                this.smsWaitingCode = true
                this.startSmsCounter(time)
            } catch (error) {
                toastr.error(error.message)
            } finally {
                this.busy = false
            }
        },
        async smsSendCode() {
            try {
                this.busy = true
                if (!this.smsCode || this.smsCode.length !== 4) return toastr.error('Debe diligenciar el código de 4 dígitos')

                const { data } = await this.$repo.post('login', { smsCode: this.smsCode })

                return !!data.status ? this.processLogin(data.user) : toastr.warning('Usuario o contraseña incorrectos')
            } catch (error) {
                console.log({ error })
                toastr.error('Ocurrió un error enviando el código, por favor intente más tarde o use otro medio de autenticación.')
            } finally {
                this.busy = false
            }
        },
        startSmsCounter(minutes) {
            const time = moment().add(minutes, 'm').format('X')
            this.smsTimerInterval = setInterval(() => {
                const now = moment().format('X')
                const distance = parseInt(time) - parseInt(now)

                if (distance < 0) {
                    clearInterval(this.smsTimerInterval)
                    this.smsTimerInterval = null
                    this.smsWaitingCode = false
                }

                this.smsTimer = moment.unix(distance).format('mm:ss')
            }, 1000)
        },

        async checkDomain() {
            const domain = window.location.hostname
            const isReseller = 'localhost' !== domain && !domain.startsWith('app') && !domain.startsWith('staging')
            this.clientChecked = true
            if (!isReseller) return
            this.setIsReseller(isReseller)
            const { data: client } = await this.$repo.get(`domains/${domain}/clients`)
            !!client && this.setCurrentClient(client)
        },

        validateAuthentication() {
            const user = localStorage.getItem('user')
            const expiration = localStorage.getItem('expiration')
            if (!user || new Date().getTime() > expiration) return false
            return user
        },
    },
    created() {
        const params = new URLSearchParams(window.location.search)
        const error = params.get('error')
        switch (error) {
            case '1':
                this.errorMessage = 'No se encontró una cuenta asociada a su dirección de correo electrónico.'
                break
            case '2':
                this.errorMessage = 'No se ha podido iniciar sesión en este momento, por favor intente con otro método de autenticación.'
                break
        }
        this.createLink()
        this.checkDomain()
        this.getClientConfig()
        let user = null

        if ((user = this.validateAuthentication())) {
            this.processLogin(JSON.parse(user))
        }
        localStorage.clear()
    },

    mounted() {
        this.validateAction()
        this.loadNotificationChannels()
    },
    beforeCreate() {
        // localStorage.clear()
    },
}
</script>
<style scoped>
.authorization-link {
    text-decoration: underline;
}
.social-buttons {
    display: flex;
    justify-content: center;
}

.social-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 27px;
    width: 40px;
    height: 40px;
    border-radius: 35%;
    color: #fff;
    text-decoration: none;
}

.whatsapp {
    background-color: #25d366;
    cursor: pointer;
}

.google {
    background-color: #fff;
    border: 1px solid #c53727;
    color: #c53727;
}

.sms {
    background-color: #fff;
    border: 1px solid #3b5998;
    color: #3b5998;
}

.facebook {
    background-color: #3b5998;
}
.zm-login-methods__title {
    margin-bottom: 1rem;
    font-weight: bold;
    text-align: center;
}
.span {
    background: #6e707e21;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    padding: 5px 5px;
    width: 70px;
    height: 32px;
    border-radius: 12%;
    color: #45464e;
    text-decoration: none;
    font-size: small;
    line-height: 1.2;
    margin: 5px 8px;
    /*  */
}
.social-button img {
    width: 100%;
    height: 100%;
    border-radius: 35%;
}
</style>
